import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { useLeadType } from '../../hooks/CompanyConfiguration/useLeadType'
import { useCustomer } from '../../hooks/Features/useCustomer'
import { FeatureContext } from '../../context api/Features/FeatureContext'
import { useLead } from '../../hooks/Features/useLeads'
import { ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router-dom'
import { EmployeeContext } from '../../context api/Employee/EmployeeContext'
import { useCompanyAdmin } from '../../hooks/CompanyAdmin/useCompanyAdmin'
import CustomAddForm from '../../components/version-4/MasterForms/CustomAddForm'

export default function AddLead({ lead }) {
  const params = useParams()
  const { getAllLeadType } = useLeadType()
  const { leadType: leadTypes } = useContext(ConfigurationContext)
  const { customers } = useContext(FeatureContext)
  const { getAllCustomer } = useCustomer()
  const { getAllEmployee } = useCompanyAdmin()
  const { employees } = useContext(EmployeeContext)
  const [error, setError] = useState(false)

  const [leadForm, setLeadForm] = useState({
    followUpDate: new Date(),
    validity: new Date(),
    customer: '',
    wishList: {},
    discountType: '',
    status: 'ACTIVE',
    discount: '',
    customerDetails: {},
    addedBy: '',
  })

  const history = useHistory()

  useEffect(() => {
    getAllCustomer()
    getAllEmployee({ rank: 6 })

    //exist and should be for add
    if (localStorage.getItem('lead') && JSON.parse(localStorage.getItem('lead')).flag === 'ADD') {
      setLeadForm({ ...leadForm, ...JSON.parse(localStorage.getItem('lead')) })
    }
  }, [])

  const discountTypeOptions = [
    { name: 'Amount', value: 'AMOUNT' },
    { name: 'Percentage', value: 'PERCENTAGE' },
  ]

  const inputField = [
    {
      label: 'Customer',
      value: leadForm.customer,
      name: 'customer',
      options: customers ? customers.filter((val) => val && val.active) : [],
      fieldValue: '_id',
      fieldName: 'name',
    },
    { label: 'Follow Up', value: leadForm.followUpDate, name: 'followUpDate', type: 'DATE', minDate: new Date() },
    { label: 'Validity', value: leadForm.validity, name: 'validity', type: 'DATE', minDate: new Date() },
    {
      label: 'Created By',
      value: leadForm.addedBy,
      name: 'addedBy',
      options: employees,
      fieldValue: '_id',
      fieldName: 'firstName',
    },
    {
      label: 'Discount Type',
      value: leadForm.discountType,
      name: 'discountType',
      options: discountTypeOptions,
      fieldValue: 'value',
      fieldName: 'name',
    },
    {
      label: 'Discount',
      value: leadForm.discount,
      name: 'discount',
      type: 'number',
      conditions: [
        { cond: (value) => leadForm.discountType === 'AMOUNT' && value < 0, message: 'Enter Valid Amount' },
        {
          cond: (value) => leadForm.discountType === 'PERCENTAGE' && (value < 0 || value > 100),
          message: 'Enter Valid Percentage',
        },
      ],
      noDisplay: leadForm.discountType ? false : true,
    },
  ]

  const handleAddLead = () => {
    history.push(ROUTES.ADD_LEAD_PRODUCTS)

    let customerDetails
    customers.forEach((val) => {
      if (val._id === leadForm.customer) {
        customerDetails = {
          address: val.address,
          city: val.city,
          profilePicture: val.profilePicture,
          name: val.name,
          state: val.state,
        }
        return
      }
    })

    localStorage.setItem('lead', JSON.stringify({ ...leadForm, customerDetails, flag: 'ADD' }))
  }

  return (
    <Layout heading="Leads" heading2="Add" url1={ROUTES.LEADS} none>
      <HeaderTabLayout
        heading="Add Lead (Valid for 1 year)"
        content={<CustomAddForm state={leadForm} setState={setLeadForm} data={inputField} setError={setError} />}
        redirect={ROUTES.LEADS}
        state={leadForm} setState={setLeadForm}
        text="Next"
        addContent={handleAddLead}
        buttonDisabled={error}
      />
    </Layout>
  )
}
